export enum PermissionsList {
  //home
  ServiceProviderHomeView = 236,
  ServiceProviderHomeCreate = 237,
  ServiceProviderHomeEdit = 238,
  ServiceProviderHomeDelete = 239,
  ServiceProviderHomeArchive = 240,

  // rides

  //active rides to be checked
  ServiceProviderActiveRidesView = 459,
  ServiceProviderActiveRidesCreate = 460,
  ServiceProviderActiveRidesEdit = 461,
  ServiceProviderActiveRidesDelete = 462,
  ServiceProviderActiveRidesArchive = 463,

  // ride simulator
  ServiceProvidersRideSimulatorView = 501,
  ServiceProvidersRideSimulatorCreate = 502,
  ServiceProvidersRideSimulatorEdit = 503,
  ServiceProvidersRideSimulatorDelete = 504,
  ServiceProvidersRideSimulatorArchive = 541,

  /*accounting */

  // my payouts
  ServiceProviderPayoutsView = 261,
  ServiceProviderPayoutsCreate = 262,
  ServiceProviderPayoutsEdit = 263,
  ServiceProviderPayoutsDelete = 264,
  ServiceProviderPayoutsArchive = 265,

  //Drivers Weekly Payouts
  ServiceProviderDriversWeeklyPayoutsView = 266,
  ServiceProviderDriversWeeklyPayoutsCreate = 267,
  ServiceProviderDriversWeeklyPayoutsEdit = 268,
  ServiceProviderDriversWeeklyPayoutsDelete = 269,
  ServiceProviderDriversWeeklyPayoutsArchive = 270,

  //Drivers Payout Statements
  ServiceProviderDriversPayoutStatementsView = 346,
  ServiceProviderDriversPayoutStatementsCreate = 347,
  ServiceProviderDriversPayoutStatementsEdit = 348,
  ServiceProviderDriversPayoutStatementsDelete = 349,
  ServiceProviderDriversPayoutStatementsArchive = 350,

  //Payout Dispute
  ServiceProviderDisputeView = 528,
  ServiceProviderDisputeCreate = 529,
  ServiceProviderDisputeEdit = 530,
  ServiceProviderDisputeDelete = 531,
  ServiceProviderDisputeArchive = 532,

  /** Routing */

  // Ride Blueprint Management
  ServiceProviderRideBluePrintView = 256,
  ServiceProviderRideBluePrintCreate = 257,
  ServiceProviderRideBluePrintEdit = 258,
  ServiceProviderRideBluePrintDelete = 259,
  ServiceProviderRideBluePrintArchive = 260,

  //Blueprint Offers
  ServiceProviderRideBlueprintOffersView = 536,
  ServiceProviderRideBlueprintOffersCreate = 537,
  ServiceProviderRideBlueprintOffersEdit = 538,
  ServiceProviderRideBlueprintOffersDelete = 539,
  ServiceProviderRideBlueprintOffersArchive = 540,

  /** Drivers */

  //leads
  ServiceProviderLeadsView = 351,
  ServiceProviderLeadsCreate = 352,
  ServiceProviderLeadsEdit = 353,
  ServiceProviderLeadsDelete = 354,
  ServiceProviderLeadsArchive = 355,

  //Drivers & Monitors
  ServiceProviderDriversAndMonitorsView = 241,
  ServiceProviderDriversAndMonitorsCreate = 242,
  ServiceProviderDriversAndMonitorsEdit = 243,
  ServiceProviderDriversAndMonitorsDelete = 244,
  ServiceProviderDriversAndMonitorsArchive = 245,

  //Drivers Data Integrity
  ServiceProviderDriversComplianceView = 356,
  ServiceProviderDriversComplianceCreate = 357,
  ServiceProviderDriversComplianceEdit = 358,
  ServiceProviderDriversComplianceDelete = 359,
  ServiceProviderDriversComplianceArchive = 360,

  /** reports */

  //arrival time reports
  ServiceProviderArrivalTimeReportView = 507,
  ServiceProviderArrivalTimeReportCreate = 508,
  ServiceProviderArrivalTimeReportEdit = 509,
  ServiceProviderArrivalTimeReportDelete = 510,
  ServiceProviderArrivalTimeReportArchive = 511,

  //edit contractor page
  ServiceProviderEditContractorEdit = 552,
  ServiceProviderEditContractorResetPassword = 553,
  ServiceProviderVehiclesView = 571,
  ServiceProviderVehiclesCreate = 572,
  ServiceProviderVehiclesEdit = 573,
  ServiceProviderVehiclesDelete = 574,
  ServiceProviderVehiclesArchive = 575,

  //arrival time reports
  ServiceProviderEquipmentAssignmentsView = 561,
  ServiceProviderEquipmentView = 556,
}
